import { getEventModelName } from "./getEventModelName";

/**
 * Deliberately structural rather than a form-metadata type: both a `Field<EventAssertion>` and an `EventFieldset` satisfy it.
 * Either half may be null — a null relation is an event whose source names none (SSV "Publication"), a null event type with the search-subject relation is Any Event.
 */
export type EventIdentity = { relation: string | null; eventType: string | null };

export const getEventInstancesPath = (identity: EventIdentity): string =>
    `events.${getEventModelName(identity)}.instances`;

/** The instance index doubles as row position: a form row at position N binds to instance N of every event identity the row's fields name, so a Death date beside a Burial place writes to index N of `SelfDeath` and index N of `SelfBurial`. */
export const getEventInstancePath = (identity: EventIdentity, instanceIndex: number): string =>
    `${getEventInstancesPath(identity)}.${instanceIndex}`;
